import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "download_crew_list_modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "download_crew_list_modal_label"
}, " Download crew list ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mb-1 fw-bolder fs-5" }, " Select shifts ", -1)
const _hoisted_11 = { class: "d-flex flex-column mt-5" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "mb-1 fw-bolder fs-5" }, " Additional fields ", -1)
const _hoisted_13 = { class: "d-flex flex-row gap-4" }
const _hoisted_14 = { class: "form-check" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "shirtSize"
}, " Shirt size ", -1)
const _hoisted_16 = { class: "form-check" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "allergies"
}, " Allergies ", -1)
const _hoisted_18 = { class: "d-flex flex-column mt-5" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "mb-1 fw-bolder fs-5" }, " Advanced Settings ", -1)
const _hoisted_20 = { class: "form-check" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "groupByWorker"
}, " Group By Worker ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "form-text text-muted" }, " If selected, the crew list will show a single list of all workers from selected shifts, with each worker appearing only once even if they are in multiple shifts. ", -1)
const _hoisted_23 = { class: "modal-footer" }
const _hoisted_24 = { class: "d-flex justify-content-end" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-1"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Download ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal(false))),
            "aria-label": "Close"
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_select, {
              modelValue: _ctx.selectedShifts,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedShifts) = $event)),
              multiple: "",
              clearable: "",
              size: "large",
              "max-collapse-tags": 3,
              placeholder: "Leave Blank to download full job list"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shifts, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.label,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "shirtSize",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.additionalFields) = $event)),
                  value: "shoesize"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.additionalFields]
                ]),
                _hoisted_15
              ]),
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "allergies",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.additionalFields) = $event)),
                  value: "allergy"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.additionalFields]
                ]),
                _hoisted_17
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "groupByWorker",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.groupByWorker) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.groupByWorker]
              ]),
              _hoisted_21,
              _hoisted_22
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              type: "button",
              disabled: _ctx.loading,
              class: "btn btn-light me-3",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleModal(false)))
            }, " Close ", 8, _hoisted_25),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleDownload && _ctx.handleDownload(...args))),
              disabled: _ctx.loading,
              type: "button",
              class: "btn btn-primary"
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27))
                : _createCommentVNode("", true),
              _hoisted_28
            ], 8, _hoisted_26)
          ])
        ])
      ])
    ])
  ]))
}